import { jsxs as h, jsx as e } from "react/jsx-runtime";
const a = ({
  color: i = "#000000",
  size: l = 24,
  variant: c = "outlined",
  title: t = "Dislike"
}) => c === "filled" ? /* @__PURE__ */ h(
  "svg",
  {
    width: l,
    height: l,
    focusable: "false",
    "aria-hidden": "true",
    viewBox: "0 0 24 24",
    "data-testid": "ThumbDownFilledIcon",
    children: [
      /* @__PURE__ */ e("title", { children: t }),
      /* @__PURE__ */ e(
        "path",
        {
          fill: i,
          d: "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z"
        }
      )
    ]
  }
) : /* @__PURE__ */ h(
  "svg",
  {
    width: l,
    height: l,
    focusable: "false",
    "aria-hidden": "true",
    viewBox: "0 0 24 24",
    "data-testid": "ThumbDownOutlinedIcon",
    children: [
      /* @__PURE__ */ e("title", { children: t }),
      /* @__PURE__ */ e(
        "path",
        {
          fill: i,
          d: "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm0 2v9.88L7.08 22.76 8.08 17H4V5h11zm4-2v12h4V3h-4z"
        }
      )
    ]
  }
);
export {
  a as default
};
